import { useState } from 'react';

import {
  DestructiveDialog,
  Input,
  makeDialog,
  Stack,
  Typography,
} from '@cast/design-system';

const CONFIRMATION_WORD = 'delete';

type Props = {
  onConfirm: () => void;
};

const ConfirmIgnorePodsWithPersistentVolumesSettingDialog = ({
  onConfirm,
}: Props) => {
  const [confirmationValue, setConfirmationValue] = useState('');

  return (
    <DestructiveDialog
      testId="confirm-ignore-pods-with-persistent-volumes-dialog"
      title="Confirm data-loss risk"
      confirmButtonText="Confirm & save"
      onConfirm={() => onConfirm()}
      slotProps={{
        root: {
          // when used inside a form, we need to stop the event from bubbling
          // due to close drawer guard mechanism
          stopClickPropagation: true,
        },
        confirmButton: {
          testId: 'confirm-button',
          disabled: confirmationValue !== CONFIRMATION_WORD,
        },
        cancelButton: {
          testId: 'cancel-button',
        },
      }}
      message={
        <Stack gap={16}>
          <Typography variant="P12R">
            You&apos;ve included{' '}
            <Typography variant="P12M" component="span">
              pods with local persistent volumes
            </Typography>{' '}
            in rebalancing. When their nodes are deleted, all data stored on
            those local volumes will be{' '}
            <Typography variant="P12M" component="span">
              permanently lost
            </Typography>{' '}
            and cannot be recovered.
          </Typography>
          <Typography variant="P12R">
            Type{' '}
            <Typography variant="P12M" component="span">
              {CONFIRMATION_WORD}
            </Typography>{' '}
            below to confirm.
          </Typography>
          <Input
            placeholder={CONFIRMATION_WORD}
            value={confirmationValue}
            onChange={(event) => setConfirmationValue(event.target.value)}
            testId="confirmation-input"
          />
        </Stack>
      }
    />
  );
};

export const useConfirmIgnorePodsWithPersistentVolumesSettingDialog =
  makeDialog(ConfirmIgnorePodsWithPersistentVolumesSettingDialog);
